import priceListBuilder from './price-list-builder.json' with { type: 'json' };
import priceLists from './price-lists.json' with { type: 'json' };

export default {
  price_list_builder: priceListBuilder,
  price_lists: priceLists,
};
